<body class="font-sans bg-gray-50">
  <app-header></app-header>

  <!-- Hero Section -->
  <section
    class="relative min-h-[60vh] md:min-h-[70vh] bg-cover bg-center bg-[url('assets/TrailFusion/Miscellaneous/24.png')]"
  >
    <div class="absolute inset-0 bg-black bg-opacity-50 z-0"></div>

    <div
      class="container mx-auto max-w-7xl flex flex-col items-center justify-center text-center relative z-10 px-4 py-12"
    >
      <!-- Logos Row -->
      <div
        class="flex flex-col sm:flex-row items-center justify-center w-full gap-6 mb-6 mt-8 md:mt-16"
      >
        <!-- Org Logo -->
        <div
          *ngIf="organization?.orgImage"
          class="flex items-center justify-center w-36 h-24 sm:w-48 sm:h-32 bg-white rounded-lg shadow-md p-2"
        >
          <img
            [src]="organization.orgImage"
            alt="Org Logo"
            class="max-h-full max-w-full object-contain"
          />
        </div>

        <!-- X Divider -->
        <span
          *ngIf="organization?.collaboratorImage"
          class="text-2xl sm:text-3xl md:text-4xl font-bold text-white"
          >X</span
        >

        <!-- Collaborator Logo -->
        <div
          *ngIf="organization?.collaboratorImage"
          class="flex items-center justify-center w-36 h-24 sm:w-48 sm:h-32 bg-white rounded-lg shadow-md p-2"
        >
          <img
            [src]="organization.collaboratorImage"
            alt="Collaborator Logo"
            class="max-h-full max-w-full object-contain"
          />
        </div>
      </div>

      <!-- Title + Button block -->
      <div class="flex flex-col items-center space-y-6">
        <h1 class="text-4xl md:text-5xl font-extrabold text-white">
          {{ organization?.orgName }}
        </h1>

        <a
          [routerLink]="['/explore-programs']"
          [queryParams]="{ orgId: organization?.id }"
          class="inline-flex items-center gap-2 bg-teal-900 text-white px-6 py-3 rounded-full hover:bg-teal-700 hover:scale-105 transition-all duration-300 group"
        >
          <span class="text-sm font-medium">Explore Now</span>
        </a>
      </div>
    </div>
  </section>

  <!-- Programs Section -->
  <section class="py-16 px-4 md:px-6 bg-white">
    <div class="container mx-auto max-w-7xl space-y-16">
      <!-- Show programs if they exist -->
      <ng-container *ngIf="programs && programs.length > 0; else noPrograms">
        <div
          *ngFor="let program of programs"
          class="flex flex-col lg:flex-row items-stretch gap-10 program-card bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300"
        >
          <!-- Left: Program Image -->
          <div class="w-full lg:w-5/12">
            <img
              [src]="
                program.programImage ||
                'assets/TrailFusion/Miscellaneous/defaultProgramImage.png'
              "
              [alt]="program.name || 'Program Image'"
              class="w-full h-full rounded-2xl shadow-lg object-cover"
            />
          </div>

          <!-- Right: Content -->
          <div class="w-full lg:w-7/12 flex flex-col justify-between space-y-8">
            <div>
              <h2
                class="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4"
              >
                {{ program.name }}
              </h2>
              <p class="text-gray-600 text-lg leading-relaxed">
                {{ program.description }}
              </p>
            </div>

            <!-- Curriculum + Outcomes -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3
                  class="text-xl font-semibold text-teal-700 mb-3 pb-1 border-b border-teal-200"
                >
                  Curriculum Outline
                </h3>
                <div [innerHTML]="program.programCurriculumOutline"></div>
              </div>
              <div>
                <h3
                  class="text-xl font-semibold text-teal-700 mb-3 pb-1 border-b border-teal-200"
                >
                  Key Outcomes
                </h3>
                <div [innerHTML]="program.programKeyOutcome"></div>
              </div>
            </div>

            <!-- Age Group + Fees -->
            <div class="flex flex-wrap gap-10 pt-4 border-t border-gray-200">
              <div>
                <h3 class="text-xl font-semibold text-teal-700 mb-2">
                  Age Groups
                </h3>
                <button
                  (click)="navigateToSignUp(program.id, program.communityId)"
                  class="bg-gradient-to-r from-teal-600 to-teal-500 text-sm font-semibold text-white px-5 py-2.5 rounded-full shadow-md hover:shadow-lg transition"
                >
                  Register Now <br />
                  <span class="font-normal">{{ program.ageGroup }}</span>
                </button>
              </div>
              <div>
                <h3 class="text-xl font-semibold text-teal-700 mb-2">
                  Program Fees
                </h3>
                <p class="text-gray-700 text-lg">
                  <span class="font-bold text-teal-800">Special Price:</span>
                  ${{ program.fee }}
                </p>
                <p class="text-gray-500 text-base line-through">
                  Regular Price: ${{ getRegularFee(program.fee) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- No Programs Template -->
      <ng-template #noPrograms>
        <div class="text-center py-16">
          <div class="max-w-md mx-auto">
            <!-- Optional: You can add an icon here -->
            <div class="mb-6">
              <svg
                class="w-24 h-24 mx-auto text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                  d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
            </div>
            <h3 class="text-2xl font-bold text-gray-700 mb-4">
              There are no programs to view at the moment
            </h3>
            <p class="text-gray-500 mb-8">
              We're working on bringing you exciting new programs. Please check
              back later.
            </p>
            <!-- Optional: Add a button to go back or explore other options -->
            <button
              routerLink="/explore-programs"
              class="bg-teal-600 hover:bg-teal-700 text-white font-semibold py-3 px-8 rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
            >
              Explore Other Programs
            </button>
          </div>
        </div>
      </ng-template>
    </div>
  </section>

  <!-- Policy Section -->
  <section class="py-16 px-4 md:px-6 bg-gray-50">
    <div class="container mx-auto max-w-7xl">
      <div
        class="bg-white p-8 rounded-xl shadow-md border border-gray-200 text-center"
      >
        <h3 class="text-2xl font-bold text-gray-800 mb-4">
          Policy Acknowledgement
        </h3>
        <p class="text-gray-600 mb-6">
          All participants must review these policies during registration.
        </p>
        <a
          *ngIf="organization?.orgPolicy"
          [href]="organization.orgPolicy"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            class="bg-teal-600 hover:bg-teal-700 text-white font-semibold py-3 px-8 rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
          >
            Download Full Policy Document
          </button>
        </a>
      </div>
    </div>
  </section>

  <app-footer></app-footer>
</body>
